import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { routes } from "../config/routes";

export const useRoutes = () => {
  const history = useHistory();

  return useMemo(() => {
    const goToRoute = (route: string) => () => {
      history.push(route);
    };

    return {
      goToLimitReached: goToRoute(routes.limitReached.raw()),
      goToFinishedAction: goToRoute(routes.finishedAction.raw()),
      goToHomePage: goToRoute(routes.homepage.raw()),
      goToCatalog: goToRoute(routes.catalog.raw()),
      goToSelectTime: goToRoute(routes.selectTimeSlot.raw()),
      goToPhoneVerification: goToRoute(routes.phoneVerification.raw()),
      goToUpsell: goToRoute(routes.upsell.raw()),
      goToSimplifyRegistration: goToRoute(routes.simplifyRegistration.raw()),
      goToPhoneVerificationError: goToRoute(routes.phoneVerificationError.raw()),
      goToRegistration: goToRoute(routes.registration.raw()),
      goToLogin: goToRoute(routes.login.raw()),
      goToRunOutOfSlots: goToRoute(routes.runOutOfSlots.raw()),
      goToSummary: (uuid: string) => {
        const summaryRoute = routes.summary.apply({ uuid });
        history.push(summaryRoute);
      },
      goToThankYouPage: (uuid: string) => {
        const thankYouRoute = routes.thankYou.apply({ uuid });
        history.push(thankYouRoute);
      },
    };
  }, [history]);
};
